import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { GridSection } from 'lib/Grid'
import { Link } from 'lib/Link'
import { PageMeta } from 'lib/PageMeta'
import { Text, Paragraph } from 'lib/Text'

const Container = styled.div`
  grid-column: 4 / 12;
  margin-top: 60px;

  ${media.tabletDown} {
    grid-column: start / end;
  }

  ${media.phoneDown} {
    margin-top: 0;
  }
`

export const NotFound = () => (
  <>
    <PageMeta index={false} />
    <GridSection>
      <Container>
        <Text weight="semi" size="xl" margin="1x">
          Brand missing
        </Text>
        <Paragraph margin="4x">The brand you were looking for could not be found.</Paragraph>
        <Text color="black-60" size="ps" margin="4x">
          If you believe this to be a mistake, please contact <Link href="mailto:support@thingtesting.com">support@thingtesting.com</Link>
        </Text>
      </Container>
    </GridSection>
  </>
)
